const SET_CLASS_ID = 'classpass/inventoryDetail/SET_CLASS_ID';
const SET_CLASS_MOVEMENT_SERP_LINKS = 'classpass/inventoryDetail/SET_CLASS_MOVEMENT_SERP_LINKS';
const SET_DYNAMIC_TAGS_INFO = 'classpass/inventoryDetail/SET_DYNAMIC_TAGS_INFO';
const SET_SCHEDULE_ID = 'classpass/inventoryDetail/SET_SCHEDULE_ID';
const SET_STUDIO_ACTIVITY_SERP_LINKS = 'classpass/inventoryDetail/SET_STUDIO_ACTIVITY_SERP_LINKS';
const SET_STUDIO_LOCATION_SERP_LINK = 'classpass/inventoryDetail/SET_STUDIO_LOCATION_SERP_LINK';
const SET_STUDIO_TAG_SERP_LINKS = 'classpass/inventoryDetail/SET_STUDIO_TAG_SERP_LINKS';
const SET_VENUE_ID = 'classpass/inventoryDetail/SET_VENUE_ID';
export const SET_VENUE_SCHEDULE_DATE = 'classpass/inventoryDetail/SET_VENUE_SCHEDULE_DATE';
const SET_VENUE_TOP_TEN_PAGES = 'classpass/inventoryDetail/SET_VENUE_TOP_TEN_PAGES';

const initialState = {
  activitySerpLinks: [],
  classId: 0,
  dynamicTagsInfo: {},
  locationSerpLink: null,
  movementSerpLinks: [],
  msaId: 0,
  scheduleId: 0,
  tagSerpLinks: [],
  venueId: 0,
  venueScheduleDate: '',
  venueTopTenPages: [],
};

export function reducer(state = initialState, action = {}) {
  const { type, ...payload } = action;

  switch (type) {
    case SET_CLASS_ID:
    case SET_CLASS_MOVEMENT_SERP_LINKS:
    case SET_DYNAMIC_TAGS_INFO:
    case SET_SCHEDULE_ID:
    case SET_STUDIO_ACTIVITY_SERP_LINKS:
    case SET_STUDIO_LOCATION_SERP_LINK:
    case SET_STUDIO_TAG_SERP_LINKS:
    case SET_VENUE_ID:
    case SET_VENUE_TOP_TEN_PAGES:
    case SET_VENUE_SCHEDULE_DATE:
      return { ...state, ...payload };
    default:
      return state;
  }
}

export const setActivitySerpLinks = activitySerpLinks => ({ type: SET_STUDIO_ACTIVITY_SERP_LINKS, activitySerpLinks });
export const setDynamicTagsInfo = dynamicTagsInfo => ({ type: SET_DYNAMIC_TAGS_INFO, dynamicTagsInfo });
export const setLocationSerpLink = locationSerpLink => ({ type: SET_STUDIO_LOCATION_SERP_LINK, locationSerpLink });
export const setMovementSerpLinks = movementSerpLinks => ({ type: SET_CLASS_MOVEMENT_SERP_LINKS, movementSerpLinks });
export const setScheduleId = scheduleId => ({ type: SET_SCHEDULE_ID, scheduleId: parseInt(scheduleId, 10) });
export const setTagSerpLinks = tagSerpLinks => ({ type: SET_STUDIO_TAG_SERP_LINKS, tagSerpLinks });
export const setVenueId = venueId => ({ type: SET_VENUE_ID, venueId: parseInt(venueId, 10) });
export const setVenueScheduleDate = venueScheduleDate => ({ type: SET_VENUE_SCHEDULE_DATE, venueScheduleDate });
export const setVenueTopTenPages = venueTopTenPages => ({ type: SET_VENUE_TOP_TEN_PAGES, venueTopTenPages });

export const selectDynamicTagsInfo = state => state.features.inventoryDetail.dynamicTagsInfo;
export const selectScheduleId = state => state.features.inventoryDetail.scheduleId;
export const selectVenueId = state => state.features.inventoryDetail.venueId;
export const selectVenueScheduleDate = state => state.features.inventoryDetail.venueScheduleDate;
